import { render } from "./tableComponent.vue?vue&type=template&id=95c19980"
import script from "./tableComponent.vue?vue&type=script&lang=js"
export * from "./tableComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__